/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { StitchTypeConsumptionDto } from '../model/';
// @ts-ignore
import type { StitchTypeCreateDto } from '../model/';
// @ts-ignore
import type { StitchTypeDto } from '../model/';
// @ts-ignore
import type { StitchTypeDtoPagedResultDto } from '../model/';
// @ts-ignore
import type { StitchTypeUpdateDto } from '../model/';
// @ts-ignore
import type { TensionTypeConsumptionDto } from '../model/';
/**
 * StitchTypeApi - axios parameter creator
 * @export
 */
export const StitchTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [customSettingId] 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculateNeedlesLengthForAllStitchTypesGet: async (customSettingId?: number, stitchTypeCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calculateNeedlesLengthForAllStitchTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (customSettingId !== undefined) {
                localVarQueryParameter['customSettingId'] = customSettingId;
            }

            if (stitchTypeCode !== undefined) {
                localVarQueryParameter['stitchTypeCode'] = stitchTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [seamThickness] 
         * @param {string} [stitchTypeCode] 
         * @param {number} [customSettingId] 
         * @param {number} [consumption1] 
         * @param {number} [consumption2] 
         * @param {number} [consumption3] 
         * @param {number} [consumption4] 
         * @param {number} [inputWaste] 
         * @param {number} [inputStitchRate] 
         * @param {number} [inputBight] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculateTensionValuesForStitchTypeGet: async (seamThickness?: number, stitchTypeCode?: string, customSettingId?: number, consumption1?: number, consumption2?: number, consumption3?: number, consumption4?: number, inputWaste?: number, inputStitchRate?: number, inputBight?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calculateTensionValuesForStitchType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (seamThickness !== undefined) {
                localVarQueryParameter['seamThickness'] = seamThickness;
            }

            if (stitchTypeCode !== undefined) {
                localVarQueryParameter['stitchTypeCode'] = stitchTypeCode;
            }

            if (customSettingId !== undefined) {
                localVarQueryParameter['customSettingId'] = customSettingId;
            }

            if (consumption1 !== undefined) {
                localVarQueryParameter['consumption1'] = consumption1;
            }

            if (consumption2 !== undefined) {
                localVarQueryParameter['consumption2'] = consumption2;
            }

            if (consumption3 !== undefined) {
                localVarQueryParameter['consumption3'] = consumption3;
            }

            if (consumption4 !== undefined) {
                localVarQueryParameter['consumption4'] = consumption4;
            }

            if (inputWaste !== undefined) {
                localVarQueryParameter['inputWaste'] = inputWaste;
            }

            if (inputStitchRate !== undefined) {
                localVarQueryParameter['inputStitchRate'] = inputStitchRate;
            }

            if (inputBight !== undefined) {
                localVarQueryParameter['inputBight'] = inputBight;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [customSetting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetStitchTypesOrderByMostFrequentlyUsedGet: async (customSetting?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getStitchTypesOrderByMostFrequentlyUsed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (customSetting !== undefined) {
                localVarQueryParameter['customSetting'] = customSetting;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeGet: async (sorting?: string, skipCount?: number, maxResultCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stitchType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStitchTypeIdDelete', 'id', id)
            const localVarPath = `/api/stitchType/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStitchTypeIdGet', 'id', id)
            const localVarPath = `/api/stitchType/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StitchTypeUpdateDto} [stitchTypeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeIdPut: async (id: number, stitchTypeUpdateDto?: StitchTypeUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStitchTypeIdPut', 'id', id)
            const localVarPath = `/api/stitchType/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stitchTypeUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StitchTypeCreateDto} [stitchTypeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypePost: async (stitchTypeCreateDto?: StitchTypeCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stitchType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stitchTypeCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StitchTypeDto} [stitchTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateStitchTypePut: async (stitchTypeDto?: StitchTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/updateStitchType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stitchTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StitchTypeApi - functional programming interface
 * @export
 */
export const StitchTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StitchTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [customSettingId] 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCalculateNeedlesLengthForAllStitchTypesGet(customSettingId?: number, stitchTypeCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: StitchTypeConsumptionDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCalculateNeedlesLengthForAllStitchTypesGet(customSettingId, stitchTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiCalculateNeedlesLengthForAllStitchTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [seamThickness] 
         * @param {string} [stitchTypeCode] 
         * @param {number} [customSettingId] 
         * @param {number} [consumption1] 
         * @param {number} [consumption2] 
         * @param {number} [consumption3] 
         * @param {number} [consumption4] 
         * @param {number} [inputWaste] 
         * @param {number} [inputStitchRate] 
         * @param {number} [inputBight] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCalculateTensionValuesForStitchTypeGet(seamThickness?: number, stitchTypeCode?: string, customSettingId?: number, consumption1?: number, consumption2?: number, consumption3?: number, consumption4?: number, inputWaste?: number, inputStitchRate?: number, inputBight?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TensionTypeConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCalculateTensionValuesForStitchTypeGet(seamThickness, stitchTypeCode, customSettingId, consumption1, consumption2, consumption3, consumption4, inputWaste, inputStitchRate, inputBight, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiCalculateTensionValuesForStitchTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [customSetting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetStitchTypesOrderByMostFrequentlyUsedGet(customSetting?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StitchTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetStitchTypesOrderByMostFrequentlyUsedGet(customSetting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiGetStitchTypesOrderByMostFrequentlyUsedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchTypeGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchTypeDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchTypeGet(sorting, skipCount, maxResultCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiStitchTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchTypeIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchTypeIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiStitchTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchTypeIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchTypeIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiStitchTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {StitchTypeUpdateDto} [stitchTypeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchTypeIdPut(id: number, stitchTypeUpdateDto?: StitchTypeUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchTypeIdPut(id, stitchTypeUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiStitchTypeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StitchTypeCreateDto} [stitchTypeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchTypePost(stitchTypeCreateDto?: StitchTypeCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchTypePost(stitchTypeCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiStitchTypePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StitchTypeDto} [stitchTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateStitchTypePut(stitchTypeDto?: StitchTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateStitchTypePut(stitchTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchTypeApi.apiUpdateStitchTypePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StitchTypeApi - factory interface
 * @export
 */
export const StitchTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StitchTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [customSettingId] 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculateNeedlesLengthForAllStitchTypesGet(customSettingId?: number, stitchTypeCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: StitchTypeConsumptionDto; }> {
            return localVarFp.apiCalculateNeedlesLengthForAllStitchTypesGet(customSettingId, stitchTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [seamThickness] 
         * @param {string} [stitchTypeCode] 
         * @param {number} [customSettingId] 
         * @param {number} [consumption1] 
         * @param {number} [consumption2] 
         * @param {number} [consumption3] 
         * @param {number} [consumption4] 
         * @param {number} [inputWaste] 
         * @param {number} [inputStitchRate] 
         * @param {number} [inputBight] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculateTensionValuesForStitchTypeGet(seamThickness?: number, stitchTypeCode?: string, customSettingId?: number, consumption1?: number, consumption2?: number, consumption3?: number, consumption4?: number, inputWaste?: number, inputStitchRate?: number, inputBight?: number, options?: RawAxiosRequestConfig): AxiosPromise<TensionTypeConsumptionDto> {
            return localVarFp.apiCalculateTensionValuesForStitchTypeGet(seamThickness, stitchTypeCode, customSettingId, consumption1, consumption2, consumption3, consumption4, inputWaste, inputStitchRate, inputBight, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [customSetting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetStitchTypesOrderByMostFrequentlyUsedGet(customSetting?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<StitchTypeDto>> {
            return localVarFp.apiGetStitchTypesOrderByMostFrequentlyUsedGet(customSetting, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<StitchTypeDtoPagedResultDto> {
            return localVarFp.apiStitchTypeGet(sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStitchTypeIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<StitchTypeDto> {
            return localVarFp.apiStitchTypeIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StitchTypeUpdateDto} [stitchTypeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypeIdPut(id: number, stitchTypeUpdateDto?: StitchTypeUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<StitchTypeDto> {
            return localVarFp.apiStitchTypeIdPut(id, stitchTypeUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StitchTypeCreateDto} [stitchTypeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchTypePost(stitchTypeCreateDto?: StitchTypeCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<StitchTypeDto> {
            return localVarFp.apiStitchTypePost(stitchTypeCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StitchTypeDto} [stitchTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateStitchTypePut(stitchTypeDto?: StitchTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiUpdateStitchTypePut(stitchTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StitchTypeApi - object-oriented interface
 * @export
 * @class StitchTypeApi
 * @extends {BaseAPI}
 */
export class StitchTypeApi extends BaseAPI {
    /**
     * 
     * @param {number} [customSettingId] 
     * @param {string} [stitchTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiCalculateNeedlesLengthForAllStitchTypesGet(customSettingId?: number, stitchTypeCode?: string, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiCalculateNeedlesLengthForAllStitchTypesGet(customSettingId, stitchTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [seamThickness] 
     * @param {string} [stitchTypeCode] 
     * @param {number} [customSettingId] 
     * @param {number} [consumption1] 
     * @param {number} [consumption2] 
     * @param {number} [consumption3] 
     * @param {number} [consumption4] 
     * @param {number} [inputWaste] 
     * @param {number} [inputStitchRate] 
     * @param {number} [inputBight] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiCalculateTensionValuesForStitchTypeGet(seamThickness?: number, stitchTypeCode?: string, customSettingId?: number, consumption1?: number, consumption2?: number, consumption3?: number, consumption4?: number, inputWaste?: number, inputStitchRate?: number, inputBight?: number, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiCalculateTensionValuesForStitchTypeGet(seamThickness, stitchTypeCode, customSettingId, consumption1, consumption2, consumption3, consumption4, inputWaste, inputStitchRate, inputBight, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [customSetting] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiGetStitchTypesOrderByMostFrequentlyUsedGet(customSetting?: number, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiGetStitchTypesOrderByMostFrequentlyUsedGet(customSetting, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiStitchTypeGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiStitchTypeGet(sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiStitchTypeIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiStitchTypeIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiStitchTypeIdGet(id: number, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiStitchTypeIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StitchTypeUpdateDto} [stitchTypeUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiStitchTypeIdPut(id: number, stitchTypeUpdateDto?: StitchTypeUpdateDto, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiStitchTypeIdPut(id, stitchTypeUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StitchTypeCreateDto} [stitchTypeCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiStitchTypePost(stitchTypeCreateDto?: StitchTypeCreateDto, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiStitchTypePost(stitchTypeCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StitchTypeDto} [stitchTypeDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchTypeApi
     */
    public apiUpdateStitchTypePut(stitchTypeDto?: StitchTypeDto, options?: RawAxiosRequestConfig) {
        return StitchTypeApiFp(this.configuration).apiUpdateStitchTypePut(stitchTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}

